import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=90e5e628&scoped=true"
import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=90e5e628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e5e628",
  null
  
)

export default component.exports